import {BehaviorSubject, Subject} from "rxjs";

export class PaymentEvents {

    /**
     * Notifies that payment details have been applied.
     */
    public static readonly paymentDetailsApplied$: Subject<void> = new Subject();

    /**
     * Notifies that the wallet payment processor creation has been resolved (may or may not exist).
     */
    public static readonly walletPaymentProcessorCreationResolved$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    /**
     * Notifies whether a wallet payment is currently being submitted.
     * This is intended to control the display of spinners.
     */
    public static readonly isSubmittingWalletPayment$: BehaviorSubject<boolean> = new BehaviorSubject(false);
}



// WEBPACK FOOTER //
// ./src/app/payment/payment-events.ts